const SortingFilter = {
    title: "Sorting",
    options: [
        {
            name: 'A-Z',
            value: 'A-Z'
        },
        {
            name: "New",
            value: "new"
        },
    ]
}


const DifficultyFilter = {
    title: "Difficulty",
    options: [
        {
            name: 'All',
            value: 'all'
        },
        {
            name: "Easy",
            value: "easy"
        },
        {
            name: "Medium",
            value: "medium"
        },
        {
            name: "Hard",
            value: "hard"
        }

    ]
}


export {
    SortingFilter,
    DifficultyFilter,
}